function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var Captcha = /*#__PURE__*/function () {
  function Captcha(props) {
    _classCallCheck(this, Captcha);
    _defineProperty(this, "onCaptchaSuccess", void 0);
    _defineProperty(this, "captcha", void 0);
    _defineProperty(this, "appid", void 0);
    // console.log('Captcha props', props);
    this.onCaptchaSuccess = props.onCaptchaSuccess;
    // this.onCaptchaSuccess = this.onCaptchaSuccess.bind(this);
    this.captcha = null;
    this.appid = '194929617';
  }
  _createClass(Captcha, [{
    key: "getCaptcha",
    value: function getCaptcha() {
      return this.captcha;
    }
  }, {
    key: "loadJS",
    value: function loadJS() {
      return new Promise(function (resolve, reject) {
        var _domScript = document.getElementById('login_captcha_script_tag');
        if (_domScript) {
          resolve('loaded');
        } else {
          var domScript = document.createElement('script');
          domScript.type = 'text/javascript';
          domScript.id = 'login_captcha_script_tag';
          domScript.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';
          domScript.onload = function () {
            resolve('loaded');
          };
          domScript.onerror = function () {
            reject('loaded');
          };
          document.getElementsByTagName('head')[0].appendChild(domScript);
        }
      });
    }
  }, {
    key: "callback",
    value: function callback(res) {
      this.captcha = res;
      this.onCaptchaSuccess && this.onCaptchaSuccess(res);
    }
  }, {
    key: "loadErrorCallback",
    value: function loadErrorCallback() {
      var appid = this.appid;
      // 生成容灾票据或自行做其它处理
      var ticket = 'terror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
      this.callback({
        ret: 0,
        randstr: '@' + Math.random().toString(36).substr(2),
        ticket: ticket,
        errorCode: 1001,
        errorMessage: 'jsload_error'
      });
    }
  }, {
    key: "showCaptcha",
    value: function showCaptcha() {
      var _this = this;
      try {
        // 生成一个验证码对象
        // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
        // callback：定义的回调函数
        this.loadJS().then(function () {
          // @ts-ignore
          var captcha = new TencentCaptcha(_this.appid, _this.callback.bind(_this), {
            userLanguage: 'zh-cn'
          });
          // 调用方法，显示验证码
          captcha.show();
        }).catch(function () {
          _this.loadErrorCallback();
        });
      } catch (error) {
        // 加载异常，调用验证码js加载错误处理函数
        console.log('error', error);
        this.loadErrorCallback();
      }
    }
  }]);
  return Captcha;
}();
export { Captcha as default };